<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil detail" style="background:#fff;">
            <a-card>
               <a-descriptions :title="detail.title"></a-descriptions>
               <a-row>
                   <a-col :span="8">
                       <span>发布时间：</span>
                       <span>{{detail.create_time}}</span>
                   </a-col>
               </a-row>
                <a-divider />

                <a-row>
                   <p>{{detail.title}}</p>
                   <p>{{detail.content}}</p>
               </a-row>
            </a-card>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '消息公告'},
            ],
            detail:""
        }
    },
    methods:{
    },
    mounted(){
        var id=this.$route.params.id
        this.$axios.get('/api/getmessagedetail',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.detail=res.data.data
            }
        })
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/message-detail.vue